import { render, staticRenderFns } from "./video1.vue?vue&type=template&id=2c1579d4&scoped=true&"
import script from "./video1.vue?vue&type=script&lang=js&"
export * from "./video1.vue?vue&type=script&lang=js&"
import style0 from "./video1.vue?vue&type=style&index=0&id=2c1579d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1579d4",
  null
  
)

export default component.exports